import axios from 'axios'
import { useContext } from 'react'
import React from 'react'
import ENDPOINT from '../data/ENDPOINT'
import SecurityHeaders from '../data/SecurityHeaders'

const GetPublicAccount = async ({payload})=>{

const data = new FormData()

data.append("session",payload.user.SessionId)
data.append("username",payload.username)
const res = await 
axios.post(ENDPOINT+"get-public-account.php",data,SecurityHeaders)
if(res){
   
     return res.data
}

}
export default GetPublicAccount